import COS from "cos-js-sdk-v5";
import { uploadConfig } from "@/config/uplodeConfig";

export function getBucket(addr, id) {
  return new Promise((resolve, reject) => {
    const cos = new COS({
      SecretId: uploadConfig.SecretId,
      SecretKey: uploadConfig.SecretKey,
    });
    cos.getBucket(
      {
        Bucket: uploadConfig.Bucket /* 填入您自己的存储桶，必须字段 */,
        Region:
          uploadConfig.Region /* 存储桶所在地域，例如ap-beijing，必须字段 */,
        Prefix:
          `${uploadConfig.appName}/` +
          addr +
          id /* Prefix表示列出的object的key以prefix开始，非必须 */,
      },
      function (err, data) {
        // imgs[i] =
        //   `https://${uploadConfig.Bucket}.cos.${uploadConfig.Region}.myqcloud.com/` +
        //   obj.Key;
        const arr = data.Contents.map((item) => {
          return {
            url:
              `https://${uploadConfig.Bucket}.cos.${uploadConfig.Region}.myqcloud.com/` +
              item.Key,
            time: item.LastModified,
          };
        }).sort((a, b) => {
          let dateA = new Date(a.time),
            dateB = new Date(b.time);
          return dateA - dateB; // 升序排序
        });
        resolve(arr.map((item) => item.url));
      }
    );
  });
}

export function arr1To2(arr, count) {
  // 原始一维数组

  // 将一维数组转为二维数组，每行包含3个元素
  const arr2 = [];
  for (let i = 0; i < arr.length; i += count) {
    arr2.push(arr.slice(i, i + count));
  }
  return arr2;
  // 输出：[[1, 2, 3], [4, 5, 6], [7, 8, 9]]
}

export function convertToOneDimensionToArray(
  oneDimensionArray,
  twoDimensionArrayLength
) {
  /**
   * 不使用slice方法，将一维数组转换为二维数组
   *
   * @param {number} twoDimensionArrayLength - 指定每个子数组的长度
   * @param {Array} oneDimensionArray - 原始的一维数组
   * @returns {Array} 二维数组
   */
  let result = [];
  let subArray = [];

  for (let i = 0; i < oneDimensionArray.length; i++) {
    subArray.push(oneDimensionArray[i]); // 向当前子数组添加元素

    // 当子数组达到指定长度或已经是最后一个元素时，将其添加到结果数组并重置子数组
    if (
      subArray.length === twoDimensionArrayLength ||
      i === oneDimensionArray.length - 1
    ) {
      result.push(subArray);
      subArray = []; // 重置子数组以填充下一个批次的元素
    }
  }

  return result;
}

export function GetUUID(len, radix) {
  var chars =
    "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz".split("");
  var uuid = [];
  var i;
  radix = radix || chars.length;

  if (len) {
    // Compact form
    for (i = 0; i < len; i++) uuid[i] = chars[0 | (Math.random() * radix)];
  } else {
    // rfc4122, version 4 form
    var r;

    // rfc4122 requires these characters
    uuid[8] = uuid[13] = uuid[18] = uuid[23] = "-";
    uuid[14] = "4";

    // Fill in random data.  At i==19 set the high bits of clock sequence as
    // per rfc4122, sec. 4.1.5
    for (i = 0; i < 36; i++) {
      if (!uuid[i]) {
        r = 0 | (Math.random() * 16);
        uuid[i] = chars[i === 19 ? (r & 0x3) | 0x8 : r];
      }
    }
  }
  return uuid.join("");
}
